import React from "react";
import { useNavigate } from "react-router-dom";
import { useLocalization } from "../../context/LocalizationContext";
import "./WelcomeScreen.css";
import welcomeVideo from "../../assets/videos/welcome.mp4";
import arrowIcon from "../../assets/icons/arrow.svg";

const WelcomeScreen = () => {
  const navigate = useNavigate();
  const { t, isRTL } = useLocalization();

  return (
    <div className="welcome-screen">
      <div className="welcome-content">
        <h1 className="welcome-title">{t("welcomeScreen.title")}</h1>
        <button
          className="welcome-start-button"
          onClick={() => navigate("/dashboard")}
        >
          {t("welcomeScreen.getStarted")}
          <img
            src={arrowIcon}
            alt="arrow"
            className="arrow-icon"
            style={{
              transform: isRTL ? "rotate(180deg)" : "none",
              marginLeft: isRTL ? 0 : "1vw",
              marginRight: isRTL ? "1vw" : 0,
              transition: "transform 0.3s ease",
            }}
          />
        </button>
      </div>
      <video className="welcome-video" autoPlay loop muted playsInline>
        <source src={welcomeVideo} type="video/mp4" />
      </video>
    </div>
  );
};

export default WelcomeScreen;
